function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 22.16L16 19.16L17.16 18L18.75 19.59L22.34 16L23.5 17.41L18.75 22.16ZM12 2C17.5 2 22 6.5 22 12L21.92 13.31C21.31 13.11 20.67 13 19.94 13L20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C12.71 20 13.39 19.91 14.05 19.74C14.13 20.42 14.33 21.06 14.62 21.65C13.78 21.88 12.9 22 12 22C6.47 22 2 17.5 2 12C2 6.5 6.47 2 12 2Z",
  className: "icon-primary"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 17V7H12.2708C13.577 7 14.5678 7.23352 15.2431 7.70055C15.9184 8.163 16.256 8.84295 16.256 9.74038C16.256 10.2303 16.1205 10.663 15.8494 11.0385C15.5783 11.4093 15.2012 11.6818 14.7181 11.8558C15.2702 11.984 15.7039 12.2427 16.0194 12.6319C16.3398 13.0211 16.5 13.4973 16.5 14.0604C16.5 15.022 16.1697 15.75 15.5092 16.2445C14.8487 16.739 13.9073 16.9908 12.6848 17H8.5ZM10.7181 12.6456V15.3448H12.6183C13.1408 15.3448 13.5474 15.2303 13.8383 15.0014C14.134 14.7679 14.2819 14.4473 14.2819 14.0398C14.2819 13.1241 13.7717 12.6593 12.7514 12.6456H10.7181ZM10.7181 11.1896H12.3595C13.4784 11.1712 14.0379 10.7569 14.0379 9.94643C14.0379 9.49313 13.8949 9.16804 13.6091 8.97115C13.3281 8.76969 12.882 8.66896 12.2708 8.66896H10.7181V11.1896Z",
  className: "icon-primary"
});

function SvgBusinessAml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "icon-primary",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessAml);
export default __webpack_public_path__ + "static/media/business-aml.d2cddee7.svg";
export { ForwardRef as ReactComponent };